module.exports = __webpack_public_path__ + "img/ic_saleorder_set.0abdf185.svg";